module.exports = __webpack_public_path__ + "img/initAct.72f3e8ea.png";